import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=070f89bd&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=070f89bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070f89bd",
  null
  
)

export default component.exports